<div class="deck-notification">
  {{ content }}
</div>
